import { Pipe, PipeTransform, Injectable } from '@angular/core';

import {SearchResultModel} from "@app/search/components/model/search-result.model";


@Pipe({
  name: 'searchResultName'
})
@Injectable({
  providedIn: 'root'
})
export class SearchResultNamePipe implements PipeTransform {

  transform(src: SearchResultModel): any {
    switch (src.type) {
      case 'project':
        return 'Akce';
      case 'subject':
        return 'Vlastník';
      case 'parcel':
        return 'Parcela';
      case 'title':
        return 'LV';
      case 'geometric_plan':
        return 'GP';
      case 'opinion':
        return 'ZP';
      case 'component':
        return 'Komponenta';
      case 'case':
        return 'Případ';
    }
  }

  mapType(type: string): 'project' | 'subject' | 'parcel' | 'title' | 'geometric_plan' | 'opinion' | 'component' | 'case' {
    switch (type) {
      case 'subject':
        return 'subject';
      case 'project':
        return 'project';
      case 'parcel':
        return 'parcel';
      case 'title':
        return 'title';
      case 'geometric_plan':
        return 'geometric_plan';
      case 'opinion':
        return 'opinion';
      case 'component':
        return 'component';
      case 'case':
        return 'case';
    }
  }
}
